import { BaseWebComponentController } from '../../../../framework/BaseWebComponentController';
import { CustomFieldsFormWebComponent } from '../component/CustomFieldsFormWebComponent';
import { CustomFieldsFormView } from '../view/CustomFieldsFormView';
import { templateCustomFieldsForm } from '../view/template';
import { CustomFieldsFormRepository } from '../repository/CustomFieldsFormRepository';
import { CustomFieldsInformation } from '../types/CustomFieldsInformation';
import { CompanyEditingRight } from '../../types/CompanyEditingRight';

export class CustomFieldsFormController extends BaseWebComponentController {
  public component: CustomFieldsFormWebComponent;
  public view: CustomFieldsFormView;
  public viewConstructor: typeof CustomFieldsFormView;
  public dataRepository: CustomFieldsFormRepository;
  public dataRepositoryConstructor: typeof CustomFieldsFormRepository;

  constructor(component: CustomFieldsFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: CustomFieldsFormView,
      viewTemplate: templateCustomFieldsForm,
      dataRepositoryConstructor: CustomFieldsFormRepository,
    });
  }

  public async getDataForView(): Promise<{
    customFieldsInformation: CustomFieldsInformation;
    editingRight: CompanyEditingRight;
  }> {
    return {
      customFieldsInformation: await this.dataRepository.getCustomFields(this.component.managedCompanyId),
      editingRight: this.component.editingRight,
    };
  }

  public async updateCustomFieldsValues(): Promise<void> {
    const value = this.component.value;

    if (!value.fields || !Array.isArray(value.fields) || !this.component.managedCompanyId) {
      return;
    }

    const customFields = value.fields.reduce((acc, curr) => ({ ...acc, [curr.name]: curr.value }), {});
    const response = await this.dependencies.api.clients.CustomFields.UpdateCustomFieldsValues(
      customFields,
      this.component.managedCompanyId
    ).toPromise();

    if (!response.success) {
      throw new Error(response.message);
    }
  }
}
